// endopod is the endoscopy product. It does not render pathology
// (WSI, PathologyShell) or radiology (MPRViewport) studies — those
// open in pathopod or tomopod respectively.
//
// These stubs let the legacy multi-modality StudyViewer.tsx (forked
// in Phase 4a) continue to compile while being unambiguous at
// runtime. The proper fix is to trim StudyViewer.tsx down to its
// endoscopy-only paths in a follow-up pass — at which point this
// file should be deleted.
//
// Grep target: `_wrongModality` — anyone cleaning up Phase 4a's
// stub debt should land here.

import type { JSX } from "solid-js";

function WrongProduct(props: { product: string; modality: string }): JSX.Element {
  return (
    <div style={{
      "display": "flex", "flex-direction": "column",
      "align-items": "center", "justify-content": "center",
      "height": "100%", "padding": "2rem",
      "color": "#e6edf3", "background": "#0b0f19",
      "text-align": "center",
    }}>
      <div style={{ "font-size": "1.5rem", "margin-bottom": "0.5rem" }}>
        {props.modality} is not part of the endopod product
      </div>
      <div style={{ "color": "#94A3B8", "max-width": "32rem" }}>
        endopod is the endoscopy product. Open this study in <strong>{props.product}</strong>.
      </div>
    </div>
  );
}

export const WSIViewport      = (_props: any) => <WrongProduct product="pathopod" modality="Whole-slide imaging (pathology)" />;
export const PathologyShell   = (_props: any) => <WrongProduct product="pathopod" modality="Pathology" />;
export const MPRViewport      = (_props: any) => <WrongProduct product="tomopod" modality="Multi-planar reformat (radiology)" />;
